import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConsent = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_5050_555)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M50 0C40.111 0 30.444 2.93245 22.2215 8.42652C13.9991 13.9206 7.59043 21.7295 3.80605 30.8658C0.0216644 40.0021 -0.968503 50.0555 0.960758 59.7545C2.89002 69.4536 7.65206 78.3627 14.6447 85.3553C21.6373 92.348 30.5465 97.11 40.2455 99.0393C49.9446 100.969 59.9979 99.9783 69.1342 96.194C78.2705 92.4096 86.0794 86.001 91.5735 77.7785C97.0676 69.5561 100 59.8891 100 50C99.9846 36.7439 94.7118 24.0352 85.3383 14.6617C75.9648 5.28824 63.2561 0.0154384 50 0Z",
				fill: "#006ADC"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_5050_555)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M54.5 38H42.5C42.1022 38 41.7206 38.158 41.4393 38.4393C41.158 38.7206 41 39.1022 41 39.5C41 39.8978 41.158 40.2794 41.4393 40.5607C41.7206 40.842 42.1022 41 42.5 41H54.5C54.8978 41 55.2794 40.842 55.5607 40.5607C55.842 40.2794 56 39.8978 56 39.5C56 39.1022 55.842 38.7206 55.5607 38.4393C55.2794 38.158 54.8978 38 54.5 38Z",
					fill: "#FBFBFB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56 46.5C56 46.1022 55.842 45.7206 55.5607 45.4393C55.2794 45.158 54.8978 45 54.5 45H38.5C38.1022 45 37.7206 45.158 37.4393 45.4393C37.158 45.7206 37 46.1022 37 46.5C37 46.8978 37.158 47.2794 37.4393 47.5607C37.7206 47.842 38.1022 48 38.5 48H54.5C54.8978 48 55.2794 47.842 55.5607 47.5607C55.842 47.2794 56 46.8978 56 46.5Z",
					fill: "#FBFBFB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.5 52C38.1022 52 37.7206 52.158 37.4393 52.4393C37.158 52.7206 37 53.1022 37 53.5C37 53.8978 37.158 54.2794 37.4393 54.5607C37.7206 54.842 38.1022 55 38.5 55H49.5C49.8978 55 50.2794 54.842 50.5607 54.5607C50.842 54.2794 51 53.8978 51 53.5C51 53.1022 50.842 52.7206 50.5607 52.4393C50.2794 52.158 49.8978 52 49.5 52H38.5Z",
					fill: "#FBFBFB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.6 63.31C51.5619 63.2187 51.4978 63.1406 51.4157 63.0855C51.3335 63.0303 51.2369 63.0006 51.138 63H34C33.7348 63 33.4804 62.8946 33.2929 62.7071C33.1054 62.5196 33 62.2652 33 62V33C33 32.7348 33.1054 32.4804 33.2929 32.2929C33.4804 32.1054 33.7348 32 34 32H60C60.2652 32 60.5196 32.1054 60.7071 32.2929C60.8946 32.4804 61 32.7348 61 33V53.14C61.0002 53.2388 61.0297 53.3354 61.0848 53.4175C61.1399 53.4996 61.2181 53.5635 61.3095 53.6012C61.4009 53.6388 61.5014 53.6486 61.5983 53.6291C61.6952 53.6097 61.7842 53.562 61.854 53.492L64.414 50.932C64.7891 50.557 64.9999 50.0484 65 49.518V32C65 30.9391 64.5786 29.9217 63.8284 29.1716C63.0783 28.4214 62.0609 28 61 28H33C31.9391 28 30.9217 28.4214 30.1716 29.1716C29.4214 29.9217 29 30.9391 29 32V63C29 64.0609 29.4214 65.0783 30.1716 65.8284C30.9217 66.5786 31.9391 67 33 67H48.736C48.9499 67 49.1582 66.9315 49.3303 66.8044C49.5023 66.6773 49.6291 66.4985 49.692 66.294C49.8824 65.6727 50.2264 65.1093 50.692 64.656L51.492 63.856C51.5621 63.7859 51.6098 63.6966 51.629 63.5994C51.6482 63.5022 51.6381 63.4015 51.6 63.31Z",
					fill: "#FBFBFB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.124 68.262C53.0597 68.1986 52.9795 68.1538 52.8918 68.1322C52.8042 68.1105 52.7123 68.113 52.6259 68.1392C52.5395 68.1654 52.4618 68.2144 52.4009 68.2811C52.34 68.3477 52.2983 68.4296 52.28 68.518L51.024 74.8C50.9943 74.9453 50.9974 75.0954 51.0329 75.2394C51.0684 75.3834 51.1354 75.5177 51.2293 75.6325C51.3231 75.7474 51.4412 75.84 51.5752 75.9035C51.7092 75.9671 51.8557 76 52.004 76C52.0712 76.0006 52.1382 75.9939 52.204 75.98L58.49 74.722C58.5786 74.7041 58.6608 74.6624 58.7276 74.6015C58.7945 74.5406 58.8435 74.4626 58.8696 74.376C58.8957 74.2894 58.8978 74.1974 58.8756 74.1097C58.8535 74.022 58.808 73.9419 58.744 73.878L53.124 68.262Z",
					fill: "#FBFBFB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.456 51.53C74.4737 50.5505 73.1431 50.0005 71.756 50.0005C70.3688 50.0005 69.0382 50.5505 68.056 51.53L55.056 64.53C54.8685 64.7175 54.7632 64.9719 54.7632 65.237C54.7632 65.5022 54.8685 65.7565 55.056 65.944L61.056 71.944C61.2435 72.1315 61.4978 72.2368 61.763 72.2368C62.0281 72.2368 62.2824 72.1315 62.47 71.944L75.47 58.944C75.9559 58.4563 76.341 57.8777 76.6033 57.2411C76.8656 56.6046 77 55.9226 76.9987 55.2341C76.9974 54.5456 76.8605 53.8642 76.5958 53.2286C76.3311 52.5931 75.9438 52.0159 75.456 51.53Z",
					fill: "#FBFBFB"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5050_555",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_5050_555",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 48,
				fill: "white",
				transform: "translate(29 28)"
			})
		})] })
	]
});
const ForwardRef = forwardRef(SvgConsent);
export default ForwardRef;
